export default __webpack_public_path__ + "media/zurb/img/genomind/helio-email-1d5ac381d5da2bf30c69a82f3afb0f0f.png";